/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const SearchPeople = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 30 30">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 15C19.7614 15 22 12.7614 22 10C22 7.23858 19.7614 5 17 5C14.2386 5 12 7.23858 12 10C12 12.7614 14.2386 15 17 15ZM17 13C18.6569 13 20 11.6569 20 10C20 8.34315 18.6569 7 17 7C15.3431 7 14 8.34315 14 10C14 11.6569 15.3431 13 17 13Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1169 25.5311C9.47403 25.8319 8.75664 26 8 26C5.23858 26 3 23.7614 3 21C3 18.2386 5.23858 16 8 16C10.7614 16 13 18.2386 13 21C13 22.2753 12.5225 23.4391 11.7366 24.3224L13.7071 26.2929C14.0976 26.6834 14.0976 27.3166 13.7071 27.7071C13.3166 28.0976 12.6834 28.0976 12.2929 27.7071L10.1169 25.5311ZM11 21C11 22.6569 9.65685 24 8 24C6.34315 24 5 22.6569 5 21C5 19.3431 6.34315 18 8 18C9.65685 18 11 19.3431 11 21Z"
      />
      <path d="M23.3333 16H14V18H23.3333C24.1674 18 25.0767 18.4729 25.8139 19.5261C26.5536 20.5827 27 22.0702 27 23.6667V27C27 27.5523 27.4477 28 28 28C28.5523 28 29 27.5523 29 27V23.6667C29 21.7269 28.4631 19.823 27.4524 18.3792C26.4393 16.9319 24.9746 16 23.3333 16Z" />
    </BaseSvgIcon>
  )
}

export default SearchPeople
